import withDesignatedLeaguesPageQuery, {
  WithDesignatedLeaguesPageQueryProps,
} from 'enhancers/withDesignatedLeaguesPageData';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import Section from 'wrappers/Section/Section';

type Props = WithDesignatedLeaguesPageQueryProps;

export const DesignatedLeagues: React.SFC<Props> = props => {
  if (
    !props.loading &&
    props.data &&
    props.data.fetch.Common.DesignatedLeagues &&
    props.data.fetch.Common.DesignatedLeagues.Content
  ) {
    return (
      <Section>
        <Markdown source={props.data.fetch.Common.DesignatedLeagues.Content} />
      </Section>
    );
  }
  return null;
};

export default withDesignatedLeaguesPageQuery(DesignatedLeagues);



// WEBPACK FOOTER //
// ./src/pages/DesignatedLeagues/DesignatedLeagues.tsx